// react-redux imports
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";

// common imports
import SectionTitle from "common/components/styled-components/SectionTitle";
import SectionTitleIndication from "common/components/styled-components/SectionTitleIndication";
import Slider from "common/components/Slider";

// stylyed-components imports
import UserInputSection from "../styled-components/UserInputSection";

import { setWaterUseMonthly } from "./householdHabitsSlice";

function StepOne() {
  const dispatch = useDispatch();
  const upDesktopScreen = useSelector(
    (state: RootState) => state.app.upDesktopScreen
  );
  const upTabletScreen = useSelector(
    (state: RootState) => state.app.upTabletScreen
  );
  const waterUseMonthly = useSelector(
    (state: RootState) => state.calculator.householdHabits.waterUseMonthly
  );

  const [waterUse, setWaterUse] = useState([waterUseMonthly]);

  function onFinalChange(values: number[]) {
    dispatch(setWaterUseMonthly(values[0]));
  }

  return (
    <>
      <SectionTitle>
        <span>¿Cuánta agua consumes? </span>
        {!upTabletScreen && <br />}
        <SectionTitleIndication>(mensual, en €)</SectionTitleIndication>
      </SectionTitle>
      <UserInputSection>
        <Slider
          min={0}
          max={150}
          maxIndicator="+150"
          values={waterUse}
          onChange={setWaterUse}
          onFinalChange={onFinalChange}
          type="secondary"
          indication={upDesktopScreen ? "(en €)" : undefined}
        />
      </UserInputSection>
    </>
  );
}

export default StepOne;
